import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import Row from "@amzn/meridian/row";
import Input from "@amzn/meridian/input";
import Button from "@amzn/meridian/button";

function ReadOnlyIbceRow({
  ibce,
  selectedNode,
  handleEditClick,
  handleDeleteClick,
}) {
  return (
    <Table spacing="small">
      <TableRow>
        <TableCell width={100}>
          <Input value={selectedNode} />
        </TableCell>
        <TableCell width={150}>
          <Input value={ibce.container} />
        </TableCell>
        <TableCell width={150}>
          <Input value={ibce.size} />
        </TableCell>
        <TableCell width={200}>
          <Input value={ibce.inbound_process} />
        </TableCell>
        <TableCell width={90}>
          <Input value={ibce.value} />
        </TableCell>
        <TableCell>
          <Row>
            <Button minWidth={70} onClick={(event) => handleDeleteClick(ibce)}>
              Delete
            </Button>
            <Button minWidth={70} onClick={(event) => handleEditClick(ibce)}>
              Edit
            </Button>
          </Row>
        </TableCell>
      </TableRow>
    </Table>
  );
}

export default ReadOnlyIbceRow;
